/* eslint-disable */

import parsePhoneNumber from 'libphonenumber-js';

export const EmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,3}$/;

export const PasswordRegex =
  /^(?=.*?\d)(?=.*?[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.*?[\u0E00-\u0E7F\u0370-\u03FF\u3040-\u309F\u30A0-\u30FFa-zA-Z])(?!.*?[^\u0E00-\u0E7F\u0370-\u03FF\u3040-\u309F\u30A0-\u30FFa-zA-Z0-9 !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,100}$/;

export const isEmail = (email: string) => EmailRegex.test(String(email).toLowerCase());

export const isNumber = (n: string) => {
  const numStr = /^\d*$/;
  return numStr.test(`${n}`);
};

export const formatPhoneNumber = (m: string) => parsePhoneNumber(m)?.formatInternational();

export const OTPAPI_BASE_URL = 'https://global-dev.amcom-corp-preprod.amway.net';

export const parseCountryCode = (phoneNumberStr: string) => {
  const obj = parsePhoneNumber(phoneNumberStr);
  return { countryCode: obj?.countryCallingCode, mobileNumber: obj?.number };
};
